import { Spacer, Text } from "@hackthenorth/north";
import { Link } from "north.js";
import React from "react";
import styled from "styled-components";

import { Field } from "src/shared/contexts/HackerContext/types";
import { useHackerState } from "src/shared/contexts/HackerContext/useHackerState";

import { showTravel } from "../home/util";

export const TravelFormSidebar: React.FC = () => {
  const { responsesState } = useHackerState([Field.TRAVEL_OPTION], {});

  const method = showTravel(responsesState[Field.TRAVEL_OPTION]);

  return (
    <SidebarContainer>
      <Text>
        You have indicated <b>{method}</b> as your travel method to Hack the
        North 2026.
      </Text>
      <Spacer height={16} />
      <Text>
        If this is incorrect, go back and edit your RSVP submission. If you need
        help changing it, contact{" "}
        <Link href="mailto:travel@hackthenorth.com">
          travel@hackthenorth.com
        </Link>
        .
      </Text>
    </SidebarContainer>
  );
};

const SidebarContainer = styled.div`
  padding-left: 48px;
  padding-right: 42px;
`;
